import { useState } from "react";

interface CustomSelectProps {
  id: string;
  options: string[];
  value: string;
  onChange: (value: string) => void;
  placeholder?: string;
}

const CustomSelect = ({
  id,
  options,
  value,
  onChange,
  placeholder = "Select an option",
}: CustomSelectProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const handleSelect = (val: string) => {
    onChange(val);
    setIsOpen(false);
  };

  return (
    <div className="relative w-full">
      <button
        id={id}
        type="button"
        onClick={() => setIsOpen(!isOpen)}
          className={`w-full px-3 py-2.5 text-sm text-left leading-none
              border border-gray-300 rounded-md focus:outline-none 
              focus:ring-2 focus:ring-blue-500 disabled:bg-gray-100 ${
                value ? "text-black" : "text-gray-500"
              }`}
      >
        {value || placeholder}
      </button>

      {isOpen && (
        <ul className="absolute z-10 w-full mt-1 bg-white border border-gray-200 rounded-md max-h-48 overflow-y-auto">
          {options.map((option) => (
            <li
              key={option}
              onClick={() => handleSelect(option)}
              className="px-4 py-2 cursor-pointer hover:bg-blue-100
                      'bg-blue-100 text-black' : ''
                    "
            >
              {option}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default CustomSelect;
